// extracted by mini-css-extract-plugin
export default {"limitFields":"LimitFields_limitFields__ebJYy"};